module.exports = __webpack_public_path__ + "img/case_03_1.340835c8.png";